import { doPOST } from '../../utils/HttpUtils';

export async function queueBulkEmail(payload: {
    emails: string[];
    subject: string;
    message: string;
}) {
    return doPOST('/bulk-email', payload);
}
